// src/utils/chargeTemplateHelpers.js
// Helpers for charge template management and manual invoice line item operations.
// supabase always passed as param — never imported directly. No DB writes outside
// of the three explicit helpers below.

export async function fetchChargeTemplates(supabase, tenantId) {
  try {
    const { data, error } = await supabase
      .from('charge_templates')
      .select('id, description, usage_count, source')
      .eq('tenant_id', tenantId)
      .order('usage_count', { ascending: false })
      .order('description', { ascending: true })
      .limit(20);
    if (error) {
      console.warn('[chargeTemplateHelpers] fetchChargeTemplates:', error.message);
      return [];
    }
    return data || [];
  } catch (err) {
    console.warn('[chargeTemplateHelpers] fetchChargeTemplates threw:', err?.message);
    return [];
  }
}

export async function recordChargeTemplateUse(supabase, tenantId, description) {
  try {
    const trimmed = description.trim();
    // Check for existing row with case-insensitive match
    const { data: existing } = await supabase
      .from('charge_templates')
      .select('id, usage_count')
      .eq('tenant_id', tenantId)
      .ilike('description', trimmed)
      .maybeSingle();

    if (existing) {
      const { data, error } = await supabase
        .from('charge_templates')
        .update({
          usage_count:  (existing.usage_count || 0) + 1,
          last_used_at: new Date().toISOString(),
        })
        .eq('id', existing.id)
        .select()
        .single();
      if (error) { console.warn('[chargeTemplateHelpers] recordChargeTemplateUse update:', error.message); return null; }
      return data;
    } else {
      const { data, error } = await supabase
        .from('charge_templates')
        .insert({
          tenant_id:    tenantId,
          description:  trimmed,
          usage_count:  1,
          source:       'auto',
          last_used_at: new Date().toISOString(),
        })
        .select()
        .single();
      if (error) { console.warn('[chargeTemplateHelpers] recordChargeTemplateUse insert:', error.message); return null; }
      return data;
    }
  } catch (err) {
    console.warn('[chargeTemplateHelpers] recordChargeTemplateUse threw:', err?.message);
    return null;
  }
}

export async function deleteInvoiceLineItem(supabase, invoiceId, lineItemId, tenantId) {
  try {
    const { data, error } = await supabase
      .from('invoice_line_items')
      .delete()
      .eq('id', lineItemId)
      .eq('invoice_id', invoiceId)
      .eq('tenant_id', tenantId)
      .select();
    if (error) {
      console.error('[deleteInvoiceLineItem] error', error);
      return false;
    }
    if (!data || data.length === 0) {
      console.warn('[deleteInvoiceLineItem] no rows deleted for', lineItemId);
      return false;
    }
    return true;
  } catch (err) {
    console.error('[deleteInvoiceLineItem] exception', err);
    return false;
  }
}
